import { SCard } from 'components/shared/s-polaris';
import { SettingUrls } from 'constants/SettingsUrls';
import { IntegrationStatusList } from 'features/settings/components/ppoints/dashboard/embedded-status/integration-status-list/IntegrationStatusList';
import { useIntegrationReadiness } from 'features/settings/components/ppoints/dashboard/embedded-status/useIntegrationReadiness';
import WizardStepItemDone from 'features/wizard/components/WizardStepItemDone';
import useReportStepLoading from 'features/wizard/hooks/useReportStepLoading';
import { WizardStepContentProps } from 'features/wizard/models/WizardStepContentProps';
import useSendClarityEvent from 'hooks/useSendClarityEvent';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { WizardStepName } from '../../../../data/ppoints/constants';
import useWizard from '../../hooks/useWizard';

export const IntegrationStatusStep: React.FC<WizardStepContentProps> = ({ onLoadingChange }) => {
    const navigate = useNavigate();
    const wizard = useWizard();
    const { t } = useTranslation();
    const { isReady, isLoading } = useIntegrationReadiness({ hideOptional: true });
    const sendClarityEvent = useSendClarityEvent();
    const stepName = WizardStepName.app_extensions;

    const isDone = wizard.isStepDone(stepName);

    useReportStepLoading(isLoading, onLoadingChange);

    useEffect(() => {
        if (!isReady || isDone) {
            return;
        }
        sendClarityEvent('ShopifyAppIntegrationClickDone');
        void wizard.markStepDone(stepName);
    }, [isReady, isDone, stepName, sendClarityEvent]);

    const handleClickAddStoreAppBlock = () => {
        sendClarityEvent('ShopifyAppIntegrationClickStarted');
    };

    if (isDone) {
        return (
            <WizardStepItemDone
                message={t('WIZARD.INTEGRATION_STATUS_STEP.DONE_DESCRIPTION')}
                action={
                    <s-button onClick={() => navigate(SettingUrls.integrationMode)}>
                        {t('WIZARD.INTEGRATION_STATUS_STEP.MODIFY_SETTINGS')}
                    </s-button>
                }
            />
        );
    }

    return (
        <div className="flex flex-col gap-2">
            <s-text>{t('WIZARD.INTEGRATION_STATUS_STEP.DESCRIPTION')}</s-text>
            <SCard padding="0">
                <div className="px-3 py-1">
                    <IntegrationStatusList
                        condensed
                        hideOptional
                        autoRefresh
                        handleClickAddStoreAppBlock={handleClickAddStoreAppBlock}
                    />
                </div>
            </SCard>
        </div>
    );
};
